import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getAreaId } from './area';

/**
 * Filter einer Liste (Bestellungen, Invoicing, Projekte & Ziele) für die Dauer des Tabs merken.
 * Wird die Liste ohne Filter geöffnet (Menü, Pfad, nach dem Löschen), kommt der zuletzt gesetzte Filter zurück.
 * „Zurücksetzen“ leert die Adresse und damit auch den gemerkten Filter.
 * sessionStorage: endet mit dem Tab, damit nicht am nächsten Tag unerwartet ein alter Filter aktiv ist.
 */
// je Bereich, weil Projekte und Kunden je Bereich verschieden sind
const KEY = (page: string) => `ft.filter.${getAreaId() ?? '-'}.${page}`;

export function rememberedQuery(page: string): string {
  try { const q = sessionStorage.getItem(KEY(page)); return q ? `?${q}` : ''; } catch { return ''; }
}

export function useRememberedFilter(page: string): void {
  const [sp, setSp] = useSearchParams();
  const q = sp.toString();
  // Erster Aufruf: ohne Filter in der Adresse den gemerkten wiederherstellen; danach jede Änderung merken.
  // pending: Wiederherstellung läuft – bis die Adresse sie zeigt, nichts überschreiben.
  const first = useRef(true);
  const pending = useRef<string | null>(null);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      if (!q) {
        let saved = '';
        try { saved = sessionStorage.getItem(KEY(page)) ?? ''; } catch { /* ohne Speicher einfach ohne Filter */ }
        if (saved) { pending.current = saved; setSp(new URLSearchParams(saved), { replace: true }); return; }
      }
    }
    if (pending.current !== null) {
      if (q !== new URLSearchParams(pending.current).toString()) return;
      pending.current = null;
    }
    try { if (q) sessionStorage.setItem(KEY(page), q); else sessionStorage.removeItem(KEY(page)); } catch { /* egal */ }
  }, [page, q, setSp]);
}
